import { Button, Card, CardBody, Col, Container, Form, FormGroup, Input, Label, Row, Table } from "reactstrap";
import { Badges, Btn, H4, Image, P } from "../../AbstractElements";
import { SearchTableButton } from "../../utils/Constant";
import { URL_API } from "../../utils/helper/helpers";
import Breadcrumbs from "../../CommonElements/Breadcrumbs/Breadcrumbs";
import SweetAlert from 'sweetalert2';
import { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import useInfosEts, { changeStatus, definirPrincipale, deleteInfo } from "./InfoApi";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { supprimerBalises, truncateText } from "../../utils/helper/helpers";
import '../../utils/helper/style.css';
import { Editor } from '@tinymce/tinymce-react';

type Infos = { [key: string]: any }

const GestInfoEts = () => {

    const [filterText, setFilterText] = useState("");
    const [filteredItems, setFilteredItems] = useState<Infos[]>([]);
    const [refresh, setRefresh] = useState(false);
    const infos = useInfosEts(refresh) || [];
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false); // Gère l'état d'envoi
    const [show, setShow] = useState(false);
    const [data, setData] = useState({
        nom: '',
        telephone: '',
        email: '',
        adresse: '',
        description: '',
        id: null
    });
    const [erreur, setErreur] = useState({
        nom: '',
        telephone: '',
        email: '',
        adresse: '',
        description: '',
        id: null
    });

    useEffect(() => {
        const filtered = infos.filter((item) =>
            item.nom && item.nom.toLowerCase().includes(filterText.toLowerCase())
        );

        if (JSON.stringify(filtered) !== JSON.stringify(filteredItems)) {
            setFilteredItems(filtered);
        }
    }, [infos, filterText, filteredItems, refresh]);

    const changeHandler = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setData((prevState) => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleCKEditorChange = (event: any, editor: any) => {
        const data = editor.getData();
        setData((prevState) => ({
            ...prevState,
            description: data
        }));
    };

    const handleEditorChange = (content: string) => {
        setData((prevState) => ({
            ...prevState,
            description: content  // Mise à jour du contenu TinyMCE
        }));
    };

    const handleSubmitData = (e: React.FormEvent) => {
        e.preventDefault();
        setIsSubmitting(true);
        const url = data.id !== null ? `${URL_API}/entreprise/update/${data.id}` : `${URL_API}/entreprise/create`
        const Token = JSON.parse(localStorage.getItem("login")!);

        axios.post(url, { ...data }, {
            headers: {
                Authorization: `Bearer ${Token}`
            }
        }).then(response => {

            if (response.data.success) {
                const msg = data.id !== null ? "ETS modifié avec succès !!" : "ETS ajouté avec succès !!";
                toast.success(msg);
                clearDataForm();
            }

        }).catch(error => {
            toast.info("Oups !! Erreur de modification des données");
            if (error.response.status == 422) {
                setErreur(error.response.data.message);
            }
        })
        setRefresh((prev) => !prev);
        setIsSubmitting(false);
    }

    const Confirmation = ({ id, type }: { id: number, type: string }) => {
        SweetAlert.fire({
            title: 'Êtes-vous sûr?',
            text: type == 'supprimer' ? "De Vouloir Supprimer cet element ??" : type == "default" ? "De vouloir definir cet element comme entreprise principale ??" : "De vouloir changer le status de cet element",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: type == 'supprimer' ? 'Oui, Supprimer !' : type == "default" ? "Oui, Définir" : 'Oui, Changer'
        }).then((result) => {
            if (result.isConfirmed) {
                type == 'supprimer' ? deleteInfo({ id: id }, () => setRefresh(!refresh)) : type == "default" ? definirPrincipale({ id: id }, () => setRefresh(!refresh)) : changeStatus({ id: id }, () => setRefresh(!refresh));
            }
        });
    };

    const editerInfosETS = ({ id }: { id: number }) => {
        const infosEts = filteredItems.find((item) => item.id === id);
        if (infosEts) {
            setData({
                nom: infosEts.nom,
                telephone: infosEts.telephone,
                email: infosEts.email,
                adresse: infosEts.adresse,
                description: infosEts.description,
                id: infosEts.id
            });
            setShow(true);
        } else {
            toast.info('Cet element de figure pas dans nos données')
        }

    }

    const clearDataForm = () => {
        setData({
            nom: '',
            telephone: '',
            email: '',
            adresse: '',
            description: '',
            id: null
        });
        setErreur({
            nom: '',
            telephone: '',
            email: '',
            adresse: '',
            description: '',
            id: null
        });
        setShow(false);
    }

    return (
        <div className='page-body'>
            <Breadcrumbs mainTitle="Informations ETS" parent="Gestions" />
            <Container fluid>
                <Row>
                    <Col md="7">
                        <Card>
                            <CardBody>
                                <Row>
                                    <Col sm="6">
                                        <div className="dataTables_filter d-flex align-items-center">
                                            <Label className="me-2">{SearchTableButton}:</Label>
                                            <Input
                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFilterText(e.target.value)}
                                                type="search"
                                                value={filterText}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                            </CardBody>

                            <div className={`theme-scrollbar table-responsive table table-striped bg-primary text-center`}>
                                <Table striped={true} hover={true} size={'sm'} responsive={"sm"}>
                                    <thead className={`tbl-strip-thad-bdr`}>
                                        <tr>
                                            <th scope="col">Id</th>
                                            <th scope="col">Nom & Adresse</th>
                                            <th scope="col">E-mail & Téléphone</th>
                                            <th scope="col">Description</th>
                                            <th scope="col">Status</th>
                                            <th scope="col">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {filteredItems.map((item, index) => (
                                            <tr key={item.id} className='text-center'>
                                                <th scope='row'>
                                                    <span className="fw-bold text-dark">
                                                        #{index + 1}
                                                    </span>
                                                </th>
                                                <td style={{ textAlign: "center" }}>
                                                    <span className="fw-bold text-dark text-capitalize">
                                                        {item.nom}
                                                    </span> <br></br>
                                                    <span>
                                                        {item.adresse}
                                                    </span>
                                                </td>
                                                <td style={{ textAlign: "center" }}>
                                                    <span className="fw-bold text-dark text-capitalize">
                                                        {item.telephone}
                                                    </span> <br></br>
                                                    <span>
                                                        {item.email}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span className="text-dark" style={{ fontSize: '13px' }} dangerouslySetInnerHTML={{ __html: truncateText(supprimerBalises(item.description), 25) }}>
                                                    </span>
                                                </td>
                                                <td>
                                                    {item.status === 'actif' ? (
                                                        <Btn className="btn btn-xs btn-success" onClick={() => Confirmation({ id: item.id, type: "changeStatus" })}>
                                                            Activer
                                                        </Btn>
                                                    ) : (
                                                        <Btn className="btn btn-xs btn-warning" onClick={() => Confirmation({ id: item.id, type: "changeStatus" })}>
                                                            Desactiver
                                                        </Btn>
                                                    )}
                                                    {
                                                        Number(item.is_default) === 1 ? (
                                                            <>
                                                                <Btn className="btn-xs for-light" color="light-dark"> Principale </Btn>
                                                                <Btn className="btn-xs for-dark" color="light-dark"> Principale </Btn>

                                                            </>) : (
                                                            null
                                                        )
                                                    }
                                                </td>
                                                <td>
                                                    <Btn className='bg-info btn-xs mx-1 my-1' onClick={() => editerInfosETS({ id: item.id })}>
                                                        <i className='fa fa-pencil'></i>
                                                    </Btn>
                                                    <Btn className='bg-danger btn-xs mx-1 my-1' onClick={() => Confirmation({ id: item.id, type: 'supprimer' })}>
                                                        <i className='fa fa-trash'></i>
                                                    </Btn>
                                                    {
                                                        Number(item.is_default) === 0 ? (
                                                            <Btn className='bg-dark btn-xs mx-1 my-1' onClick={() => Confirmation({ id: item.id, type: 'default' })}>
                                                                {/* <i className='fa fa-trash'></i> */}
                                                                Definir
                                                            </Btn>
                                                        ) : (
                                                            null
                                                        )
                                                    }

                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>
                        </Card>
                    </Col>
                    <Col md="5">
                        <Card>
                            <CardBody>
                                <Form onSubmit={handleSubmitData}>
                                    <H4 className="my-4 text-capitalize">
                                        {
                                            data.id == null ? ("Ajouter un établissement") : ("Modification de l'établissement " + data.nom)
                                        }
                                    </H4>

                                    <div className="product-info">
                                        <div className="product-group">
                                            <Row>
                                                <Col sm="6">
                                                    <FormGroup>
                                                        <Label>Nom</Label>
                                                        <Input
                                                            placeholder="Entrer le nom"
                                                            name="nom"
                                                            value={data.nom}
                                                            onChange={changeHandler}
                                                            type="text"
                                                        />
                                                        {erreur.nom && (
                                                            <span className="text-danger">{erreur.nom}</span>
                                                        )}
                                                    </FormGroup>
                                                </Col>
                                                <Col sm="6">
                                                    <FormGroup>
                                                        <Label>Adresse</Label>
                                                        <Input
                                                            placeholder="Entrer le adresse"
                                                            name="adresse"
                                                            value={data.adresse}
                                                            onChange={changeHandler}
                                                            type="text"
                                                        />
                                                        {erreur.adresse && (
                                                            <span className="text-danger">{erreur.adresse}</span>
                                                        )}
                                                    </FormGroup>
                                                </Col>
                                                <Col sm="6">
                                                    <FormGroup>
                                                        <Label>E-mail</Label>
                                                        <Input
                                                            placeholder="Entrer le E-mail"
                                                            name="email"
                                                            value={data.email}
                                                            onChange={changeHandler}
                                                            type="text"
                                                        />
                                                        {erreur.email && (
                                                            <span className="text-danger">{erreur.email}</span>
                                                        )}
                                                    </FormGroup>
                                                </Col>
                                                <Col sm="6">
                                                    <FormGroup>
                                                        <Label>Téléphone</Label>
                                                        <Input
                                                            placeholder="Entrer le téléphone"
                                                            name="telephone"
                                                            value={data.telephone}
                                                            onChange={changeHandler}
                                                            type="number"
                                                        />
                                                        {erreur.telephone && (
                                                            <span className="text-danger">{erreur.telephone}</span>
                                                        )}
                                                    </FormGroup>
                                                </Col>
                                                <Col sm="12">
                                                    {show === false ? (
                                                        <FormGroup>
                                                            <Label>Descriptions</Label>
                                                            <CKEditor
                                                                editor={ClassicEditor}
                                                                data={data.description}
                                                                name='desc'
                                                                onChange={handleCKEditorChange}
                                                            />
                                                            {/* <Editor
                                                                apiKey="t2v601y9x4wn3oleidxqigmkfdtfe69flx9edrqzsum87up7"
                                                                value={data.description}
                                                                onEditorChange={handleEditorChange}
                                                                init={{
                                                                    plugins: [
                                                                        'anchor', 'autolink', 'charmap', 'codesample', 'emoticons', 'image', 'link', 'lists', 'media', 'searchreplace', 'table', 'visualblocks', 'wordcount',
                                                                    ],
                                                                    toolbar: 'undo redo | bold italic underline strikethrough fontfamily fontsize image',
                                                                    tinycomments_mode: 'embedded',
                                                                    tinycomments_author: 'DEV GN',
                                                                    // mergetags_list: [
                                                                    //     { value: 'First.Name', title: 'First Name' },
                                                                    //     { value: 'Email', title: 'Email' },
                                                                    // ],
                                                                }}
                                                            /> */}
                                                            {erreur.description && (
                                                                <span className="text-danger">{erreur.description}</span>
                                                            )}
                                                        </FormGroup>
                                                    ) : (
                                                        <div className="text-dark text-center" dangerouslySetInnerHTML={{ __html: data.description }} onClick={() => setShow(!show)}></div>
                                                    )}
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                    <div className="text-end">
                                        <Btn color="info" type="submit" disabled={isSubmitting}>
                                        {data.id == null ? (isSubmitting ? "En cours d'ajout..." : "Ajouter") : (isSubmitting ? "Sauvegarde en cours..." : "Sauvegarder")}
                                        </Btn>
                                        <Btn className="btn btn-danger ms-3" onClick={() => clearDataForm()}>
                                            Annuler
                                        </Btn>
                                    </div>
                                </Form>
                            </CardBody>

                        </Card>

                    </Col>
                </Row>
            </Container>
        </div>

    )
}

export default GestInfoEts
